var _config = undefined;
export default {
    get config() {
        return _config;
    },
    set config(val) {
        _config = val;
    },
};
